// @ts-nocheck
import { useTranslation } from 'react-i18next';
import { formatCheckoutCharge } from '../../../utils/checkoutCurrency';
import './CheckoutCurrencyNotice.css';

const CheckoutCurrencyNotice = ({
  currencyState,
  operatorCurrency,
  operatorName,
  showOperatorCurrency = true,
  inline = false
}) => {
  const { t, i18n } = useTranslation('bookings');
  const state = currencyState;
  if (!state?.managed) return null;
  const selection = state.pendingSelection || state.selection;
  const amount = formatCheckoutCharge(selection, i18n.resolvedLanguage || 'en');
  const foreign = Boolean(
    selection &&
    operatorCurrency &&
    selection.currency !== operatorCurrency.toUpperCase()
  );
  const errorMessage = state.error?.details?.paymentIntentStatus
    ? 'currencyPayment.cannotChange'
    : state.error?.name === 'FX_CARD_UNAVAILABLE'
      ? 'currencyPayment.cardUnavailable'
      : state.error?.name === 'FX_PAYMENT_METHOD_UNAVAILABLE'
        ? 'currencyPayment.methodUnavailable'
        : 'currencyPayment.failed';
  if (!foreign && !state.error) return null;
  return (
    <div
      className={`checkout-currency-notice${inline ? ' checkout-currency-notice--inline' : ''}`}
      aria-live='polite'
    >
      {selection && foreign && showOperatorCurrency && (
        <p className='checkout-currency-notice__credit'>
          {t('currencyPayment.operatorReceives', {
            operatorName: operatorName || t('currencyPayment.operator'),
            currency: operatorCurrency.toUpperCase()
          })}
        </p>
      )}
      {selection && foreign && (
        <div className='checkout-currency-notice__amount text-sm-bold'>
          <span>{t('currencyPayment.chargedAmount')}</span>
          <strong>{amount}</strong>
        </div>
      )}
      {state.error && (
        <div role='alert'>
          <p>{t(errorMessage)}</p>
          {!state.error.details?.paymentIntentStatus && (
            <button
              type='button'
              disabled={state.loading}
              onClick={state.retry}
            >
              {t('currencyPayment.retry')}
            </button>
          )}
        </div>
      )}
    </div>
  );
};
export default CheckoutCurrencyNotice;
